export const columnLayout = (onIncomeButtonClick, popDepartureImage) => {
  const gridColumnLayOut = [
    {
      dataField: "kakaotalkYn",
      headerText: "입차호출",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      renderer: {
        type: "ButtonRenderer",
        labelText: "입차호출",
        onClick: onIncomeButtonClick,
        visibleFunction: function (
          rowIndex,
          columnIndex,
          value,
          item,
          dataField
        ) {
          // 행 아이템의 transStatusCd 이 도착상태가 등록으로 되어 있으면  라면 버튼 표시

          if (
            (item.transStatusCd === "A" ||
              item.transStatusCd === "N" ||
              item.transStatusCd === "G") &&
            item.tmsOdrNo !== "" &&
            item.odrType !== "80"
          ) {
            return true;
          }
          return false;
        },
      },
      labelFunction: function (rowIndex, columnIndex, value, headerText, item) {
        if (item.transStatusCd === "G") {
          return "입차취소";
        } else if (item.transStatusCd === "A" || item.transStatusCd === "N") {
          return "입차호출";
        }
        return value;
      },
    },

    {
      dataField: "wghtDt",
      headerText: "입고일자",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "systemCd",
      headerText: "회사구분",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "transStatusCd",
      headerText: "배차상태",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "transStatusCdNm",
      headerText: "배차상태",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      styleFunction: function (
        rowIndex,
        columnIndex,
        value,
        headerText,
        item,
        dataField
      ) {
        if (item.transStatusCd === "T" || item.transStatusCd === "R") {
          return "my-cell-style1";
        } else if (item.transStatusCd === "D") {
          return "my-cell-style2";
        } else if (item.transStatusCd === "A") {
          return "my-cell-style3";
        } else if (item.transStatusCd === "W") {
          return "my-cell-style4";
        } else if (item.transStatusCd === "S" || item.transStatusCd === "I") {
          return "my-cell-style5";
        }
        return null;
      },
    },
    {
      dataField: "odrType",
      headerText: "배차종류",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "odrTypeNm",
      headerText: "배차종류",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "plantCd",
      headerText: "사업장구분",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "plantNm",
      headerText: "사업장(출발지공장)",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "poaPlantNm",
      headerText: "사업장(도착지공장)",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "poaPlantCd",
      headerText: "사업장구분",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "itemCd",
      headerText: "사전등급",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "itemNm",
      headerText: "사전등급",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "vndrCd",
      headerText: "공급업체 코드",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "vndrNm",
      headerText: "공급업체(운송업체)",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "rvndrCd",
      headerText: "실공급업체 코드",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "rvndrNm",
      headerText: "실공급업체",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "vhclNo",
      headerText: "차량번호",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "vhclNo4",
      headerText: "차량번호",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "drivNm",
      headerText: "운전자",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "drivTel",
      headerText: "전화번호",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "loadAreaAddr",
      headerText: "상차지역",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "startImg",
      headerText: "출발보고사진",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      renderer: {
        type: "ButtonRenderer",
        labelText: "사진",
        onClick: popDepartureImage,
        visibleFunction: function (
          rowIndex,
          columnIndex,
          value,
          item,
          dataField
        ) {
          // 행 아이템의 name 이 운송상태가 등록으로 되어 있으면  라면 버튼 표시
          if (
            item.odrType === "10" &&
            (item.transStatusCd === "D" ||
              item.transStatusCd === "A" ||
              item.transStatusCd === "W" ||
              item.transStatusCd === "I" ||
              item.transStatusCd === "G" ||
              item.transStatusCd === "S")
          ) {
            return true;
          }
          return false;
        },
      },
    },
    {
      dataField: "arrvDt",
      headerText: "도착시간",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "itemEtcCdNm",
      headerText: "비고1",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "itemEtcCd",
      headerText: "비고1",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "itemEtcRmksNm",
      headerText: "비고2",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "itemEtcRmks",
      headerText: "비고2",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "tmsOdrNo",
      headerText: "배차번호",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
  ];
  return gridColumnLayOut;
};
